import { useContext } from 'react';

import { useMe } from '@/hooks/use-me';

import { WarrantyDetailsContext } from '../../pages/warranty-details';
import { GetPerformanceWarrantyStates } from '../../queries/get-performance-warranty-states';
import { PlotSection } from '../plot-section';
import { SectionSkeleton } from '../skeletons/SectionSkeleton';

import { GaugeCard } from './gauge-card';
import { GaugeLegend } from './gauge-legend';
import { IntroBox } from './intro-box';

export type PenaltyTableProps = {};

export function GuaranteeGaugeSection(_: PenaltyTableProps) {
  const me = useMe();
  const asset = useContext(WarrantyDetailsContext);

  const performanceWarrantyStates = GetPerformanceWarrantyStates.useQuery({
    assetFullFrontendId: asset!.fullFrontendId,
    customerId: me.config.id,
  });

  if (performanceWarrantyStates.isLoading)
    return (
      <SectionSkeleton sectionName="Performance Guarantee States (on Site Level)" />
    );
  if (performanceWarrantyStates.isError)
    return <div>Error loading Warranty overview</div>;

  // check if warrantyResult is undefined or empty
  if (
    !performanceWarrantyStates.data ||
    Object.values(performanceWarrantyStates.data).every(
      (metric) => metric === undefined,
    )
  ) {
    return (
      <div className="py-4 text-center">
        <p>No data available</p>
      </div>
    );
  }

  // Metrics map is now directly returned from the query
  const metricsMap = performanceWarrantyStates.data;

  // For each gauge, show a placeholder if aggregationLevel !== 'array', else show the real card
  // TODO: check if `array` is the correct value for aggregationLevel, or if the aggregation needs to be changed
  return (
    <PlotSection sectionName="Performance Guarantee States (on Site Level)">
      <IntroBox />
      <GaugeLegend
        showPrediction={Object.values(metricsMap).some(
          (m) => m?.futurePrediction !== undefined,
        )}
      />
      <div className="grid grid-cols-1 place-items-center gap-x-0 gap-y-8 md:grid-cols-3 md:gap-x-8 md:gap-y-12">
        <GaugeCard key="SOH" metric={metricsMap.SOH} />
        <GaugeCard key="RTE" metric={metricsMap.RTE} />
        <GaugeCard key="TAG" metric={metricsMap.TAG} />
      </div>
    </PlotSection>
  );
}

GuaranteeGaugeSection.displayName = 'GuaranteeGauge';
